<template>
  <section class="current-data tw-grid tw-grid-cols-5 tw-gap-4">
    <div
      v-for="content in contents"
      :key="content.title"
      class="tw-bg-white tw-border tw-rounded-sm tw-p-4"
    >
      <div class="card-title tw-text-xl">{{ content.title }}</div>
      <div
        class="card-value tw-text-right tw-text-primary tw-font-bold tw-text-[4rem]"
      >
        {{ content.value | numFormat }}
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CurrentData",
  props: {
    filter: Object,
  },
  data() {
    return {
      updateInterval: null,
      contents: {
        totalCreatedRoom: {
          title: "Total rooms",
          value: "-",
        },
        totalCustomer: {
          title: "Total customers",
          value: "-",
        },
        totalMessage: {
          title: "Total messages",
          value: "-",
        },
        totalAgent: {
          title: "Total agents",
          value: "-",
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      agents: "chat/agents",
    }),
  },
  mounted() {
    this.updateContent();
    this.updateInterval = setInterval(async () => {
      await this.updateContent();
    }, 1000 * 60);
  },
  watch: {
    agents: {
      immediate: true,
      handler: function () {
        const agents = this.$store.getters["chat/agents"];
        this.contents.totalAgent.value = agents.length;
      },
    },
  },
  methods: {
    async updateContent() {
      console.log("updateContent");
      const totalRooms = await this.$store.dispatch("chat/getTotalCreatedRoom");
      this.contents.totalCreatedRoom.value = totalRooms;
      this.contents.totalCustomer.value = totalRooms;
      const totalMessage = await this.$store.dispatch("chat/getTotalMessage");
      this.contents.totalMessage.value = totalMessage;
    },
  },
  filters: {
    numFormat(value) {
      return value?.toLocaleString();
    },
  },
  beforeDestroy() {
    clearInterval(this.updateInterval);
  },
};
</script>

<style>

</style>
